import { useQuery } from '@tanstack/react-query';

import { sessionsV3PreviewSessionOptions } from '@/api/generated/@tanstack/react-query.gen';

/**
 * Query hook to check if a session recovery token is valid.
 */
export function useGetSessionPreviewQuery(token: string) {
  return useQuery({
    ...sessionsV3PreviewSessionOptions({ path: { token } }),
    staleTime: Infinity,
    retry: false,
  });
}
